export default "__VITE_ASSET__CIYeJxdP__"